import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useStartAiExtendedReviewMutation = () => {
  const { sims } = useAvApi();

  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['ai-extended-review', 'start'],
    mutationFn: async ({
      scenarioId,
      persona,
      amount,
    }: {
      scenarioId: string;
      persona: 'accessible' | 'default' | string,
      amount: number;
    }) => {
      if (!scenarioId) return;

      const res = await sims.postSimulationExtendedById(
        null,
        {
          id: scenarioId,
        },
        { amount, persona }
      );

      return res.data;
    },
    onSuccess: (_, { scenarioId }) => {
      queryClient.invalidateQueries({
        queryKey: ['scenario-ai-reviews', scenarioId],
        refetchType: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: ['scenario-ai-latest-review', scenarioId],
        refetchType: 'all',
      });
    },
  });
};
